import React from "react";

import classes from "./styles.module.scss";

import VoltaBlueSmallLogo from "assets/images/icons/voltaSmallBlueLogo.svg";
import CloseIcon from "assets/images/icons/Close.svg";

const Header = ({ onClose }) => {
    return (
        <div className={classes.paymentModalHeader}>
            <div className={classes.paymentModalHeaderTextWrapper}>
                <img src={VoltaBlueSmallLogo} alt="VoltaBlueSmallLogo" />
                <p>Buy Credits</p>
            </div>
            <img style={{ cursor: "pointer" }} src={CloseIcon} alt="CloseIcon" onClick={onClose} />
        </div>
    );
};

export default Header;
